// Bilingual content for the Narwhal site (mock data layer).
// Structured as content[lang].{section}

const BLOG_IMG = {
  eco: "https://images.unsplash.com/photo-1639322537228-f710d846310a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  ai: "https://images.unsplash.com/photo-1561233835-f937539b95b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  sales: "https://images.unsplash.com/photo-1620121692029-d088224ddc74?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
};

export const content = {
  es: {
    nav: {
      links: [
        { id: "inicio", label: "Narwhal" },
        { id: "nosotros", label: "Nosotros" },
        { id: "servicios", label: "Servicios" },
        { id: "recursos", label: "Recursos", dropdown: [
          { label: "Blogs", section: "blogs" },
          { label: "Casos de éxito", section: "casos" },
          { label: "Preguntas frecuentes", section: "faq" },
          { label: "Glosario", section: "glosario" },
          { label: "Descargables", section: "descargables" },
        ] },
      ],
      cta: "Agendá una llamada",
      menu: "Menú de navegación",
      closeMenu: "Cerrar menú",
      home: "Narwhal - Inicio",
    },
    hero: {
      kicker: "Aceleración comercial",
      titleTop: "Tu Dirección de Negocios",
      titleAccent: "B2B as a Service.",
      titleAccentLines: ["B2B as a Service."],
      imageAlt: "Dashboard de Narwhal con su logo oficial, ingresos potenciados, leads generados, proyectos activos, reuniones y crecimiento del pipeline.",
      sub: "B2B exige coordinar ciclos largos, múltiples decisores y esfuerzos que deben sostenerse sin pausa. Narwhal arma y sostiene ese equipo completo, bajo una sola dirección.",
      cta: "Agendá una llamada",
      cta2: "Conocé la Capa 1",
      tagline: "Estrategia × Ejecución × Resultados",
      dashboard: {
        label: "Pipeline",
        value: "$2.4M",
        metrics: [
          { label: "Leads", value: "342" },
          { label: "Reuniones", value: "87" },
          { label: "Oportunidades", value: "23" },
          { label: "Conversiones", value: "12" },
        ],
        note: "Toda tu operación B2B en un solo lugar.",
      },
    },
    stats: [
      { value: "+15", label: "profesionales en tu equipo" },
      { value: "4", label: "gerencias + 1 Dirección" },
      { value: "+8", label: "estrategias en simultáneo" },
      { value: "15 días", label: "para estar operando" },
    ],
    problem: {
      kicker: "El problema del crecimiento B2B",
      title: "Cada solución resuelve una parte",
      titleAccent: "y agrega nuevos desafíos.",
      body: "Equipos internos, agencias, consultoras y proveedores pueden aportar valor, pero también introducen nuevas complejidades que limitan el crecimiento.",
      columns: [
        { name: "Equipos internos", caption: "Buen talento, pero no alcanza.", points: ["Meses para armar la estructura", "Alto costo fijo", "Necesidad de múltiples perfiles especializados", "Complejidad de gestión y coordinación", "Dependencia de personas clave"] },
        { name: "Agencias / proveedores", caption: "Especialistas por área, pero sin una visión completa.", points: ["Trabajan por canal o servicio", "Costos acumulados entre proveedores", "Upselling constante", "Necesidad de coordinación interna", "Esfuerzos desconectados"] },
        { name: "Consultoras", caption: "Estrategia sin involucramiento operativo.", points: ["Diagnostican", "No ejecutan el día a día", "Procesos largos", "Requieren recursos internos adicionales", "Baja exposición al resultado"] },
      ],
    },
    challenge: {
      kicker: "El desafío real",
      title: "El crecimiento B2B no tiene un",
      titleAccent: "único desafío.",
      body: "Múltiples desafíos interactúan y se potencian entre sí. Resolver una parte no alcanza si las demás siguen limitando el resultado.",
      orbit: ["Estrategia", "Tecnología", "Datos", "Ejecución", "Demanda"],
      items: [
        { icon: "network", title: "Complejidad estructural", text: "No hay un solo frente que resolver: son múltiples estrategias interdependientes que deben funcionar y sostenerse en simultáneo." },
        { icon: "coins", title: "Restricción económica", text: "Construir toda la capacidad interna es costoso, y tercerizarla por partes acumula fees, herramientas y coordinación." },
        { icon: "clock", title: "Restricción de tiempo", text: "Formar equipos, sumar conocimiento y ordenar procesos lleva meses, pero el negocio no puede dejar de vender." },
        { icon: "alert", title: "Desgaste acumulado", text: "Personas, agencias e iniciativas resolvieron partes, no el conjunto. Cada intento fallido suma costo, tiempo y desconfianza." },
        { icon: "chart", title: "Presión competitiva", text: "Mientras ordenás tu sistema comercial, el mercado avanza. No hacer nada también es un costo." },
        { icon: "user", title: "Carga de dirección", text: "Alguien tiene que decidir, coordinar y controlar todo, sin un tablero único. Esa carga recae en el CEO o responsable comercial." },
        { icon: "eye", title: "Poca visibilidad", text: "Cuesta saber qué se está haciendo, si algo avanza, si hay resultados y quién trabaja en qué, sin un lugar único para controlarlo rápido." },
      ],
      closingTitle: "Narwhal no resuelve uno de estos desafíos.",
      closingAccent: "Resuelve el problema de tenerlos todos al mismo tiempo.",
    },
    model: {
      kicker: "El modelo",
      title: "De nada a un equipo",
      titleSecondLine: "en marcha en",
      titleAccent: "15 días.",
      body: "Por un único fee, sin upselling estructural y sin curva de aprendizaje, un CEO pasa de cero a tener un ecosistema completo funcionando.",
      chart: {
        root: "Dirección de Negocios",
        rootCaption: "Estrategia, coordinación y resultados",
        orgTagline: "Un solo equipo. Una sola dirección.",
        areas: [
          { title: "Desarrollo de Negocios", description: "Pipeline real, no solo leads.", items: ["Outbound estratégico", "Account research", "Gestión de oportunidades"] },
          { title: "Marketing", description: "Demanda que conecta con negocio.", items: ["Estrategia y campañas", "SEO / GEO", "Contenido y performance"] },
          { title: "Comunicación & Posicionamiento", description: "Reputación que genera oportunidades.", items: ["LinkedIn y PR", "Contenido estratégico", "Eventos y alianzas"] },
          { title: "Tech, Datos & Performance", description: "Infraestructura para escalar.", items: ["CRM y automatización", "Datos y reporting", "Optimización continua"] },
        ],
        nodes: ["Desarrollo de Negocios ABM", "Marketing ABM", "Comunicación & Posicionamiento", "Tech, Datos & Performance"],
      },
      price: {
        label: "Un único fee mensual",
        amount: "USD 3.200",
        per: "/mes",
        checks: ["Sin retainer ni permanencias mínimas.", "Todo el stack tecnológico incluido."],
        includesTitle: "Incluye",
        includes: ["+15 profesionales", "4 gerencias", "Dirección de Negocios", "Stack tecnológico", "Reporting continuo", "Reuniones quincenales", "Documentación y know-how"],
        cta: "Quiero mi revisión estratégica",
      },
    },
    why: {
      kicker: "Por qué Narwhal",
      title: "El único modelo que asume",
      titleAccent: "toda la complejidad del B2B.",
      items: [
        {
          title: "Ecosistema mínimo viable", text: "La base indispensable, ejecutada con profesionalismo.",
          definition: "Es todo lo que tu empresa debería estar haciendo sí o sí para competir en el corto, mediano y largo plazo. Hay mil cosas posibles, pero existe una base indispensable: todos los frentes necesarios funcionan coordinados y ejecutados con profesionalismo, no como acciones sueltas.",
        },
        {
          title: "Tranquilidad", text: "Saber que todo lo que hay que hacer, se está haciendo.",
          definition: "No es una sensación vaga: es el resultado directo de la trazabilidad total y del reporte mes a mes. Siempre hay un responsable que te cuenta cómo avanza cada frente.",
        },
        {
          title: "Partner de negocio", text: "Un equipo interno real, no un proveedor más.",
          definition: "Buscamos que sientas que sumaste un equipo interno alineado con tus objetivos. Aportamos el know-how y el criterio como si fuéramos parte de tu empresa, no un proveedor externo más.",
        },
        {
          title: "Transparencia", text: "Resultados reales, buenos o malos, sin maquillar.",
          definition: "Compartimos los resultados tal cual son, sin inflar métricas para justificar el fee. Esa honestidad es la base de la paz mental que ofrece Narwhal: no prometemos que todo saldrá bien, damos la certeza de verlo tal cual es, siempre, gracias a la tecnología propia que reporta todo.",
        },
        {
          title: "Visibilidad total", text: "Toda la operación en una plataforma propia.",
          definition: "La plataforma tecnológica propia de Narwhal integra todas las herramientas y canales. Desde un solo lugar ves absolutamente todo con información real: no solo nuestra ejecución, sino todos los indicadores que van saliendo.",
        },
        {
          title: "Costo de oportunidad", text: "El mejor resultado posible con la menor inversión.",
          definition: "Por USD 3.200 hoy apenas conseguís dos perfiles semisenior o uno senior, sin garantía de que sepan qué hacer ni de que cubran todo. Una agencia ya se acerca a ese ticket con una sola estrategia, arrancando de cero cada vez y sin quedar conectada con el resto del negocio. No existe alternativa comparable a ese precio.",
        },
        {
          title: "Tecnología propia", text: "Todo el stack, ya armado y probado.",
          definition: "Cubrimos todo el stack tecnológico necesario, pero lo central es la tecnología propia que integra todas las plataformas y reporta absolutamente todo. Ya está armada y probada, sin los meses de desarrollo que llevaría construirla desde cero.",
        },
        {
          title: "Sin curva de aprendizaje", text: "El ecosistema ya está funcionando.",
          definition: "El ecosistema ya está armado y en marcha; no se construye desde cero con cada cliente. Empezás a operar sin los meses de puesta a punto.",
        },
        {
          title: "Un único fee", text: "Sin upselling forzado ni costos ocultos.",
          definition: "El fee incluye todo el stack tecnológico necesario y no depende de justificar actividad ni de venderte capas adicionales de servicio. Muchas cosas que una agencia cobraría aparte, nosotros las incluimos.",
        },
        {
          title: "Sin ataduras", text: "Te quedás por el valor que recibís.",
          definition: "No hay retainer ni permanencias mínimas. Buscamos que te quedes por el valor que recibís, no por estar atado a un contrato. La relación se sostiene en el aporte del equipo a tu negocio.",
        },
        {
          title: "Equipo senior", text: "No juniors aprendiendo sobre la marcha.",
          definition: "Más de 15 profesionales, organizados en cuatro gerencias y una Dirección de Negocios. Un equipo senior dedicado, que aporta know-how y criterio como parte de tu empresa, en lugar de recursos junior aprendiendo sobre la marcha.",
        },
        {
          title: "Know-how que queda", text: "Procesos y conocimiento para tu empresa.",
          definition: "El conocimiento y los criterios generados quedan con vos, no encapsulados en el proveedor. La documentación y los procesos forman parte del trabajo, para que tu empresa conserve lo aprendido y pueda seguir construyendo sobre esa base.",
        },
      ],
      link: "Explorar los diferenciales",
      detail: { label: "Diferencial", previous: "Diferencial anterior", next: "Siguiente diferencial", close: "Cerrar detalle" },
    },
    tech: {
      kicker: "Tech driven",
      title: "Todo el negocio en un solo lugar.",
      body: "La plataforma tecnológica propia de Narwhal integra todas las herramientas y canales. Desde un solo lugar ves absolutamente todo con información real: no solo nuestra ejecución, sino todos los indicadores que van saliendo.",
      list: ["Desarrollo de Negocios", "Pipeline comercial", "IA, Búsqueda & Visibilidad", "Contenido & Marca", "Paid Media", "Gestión Operativa", "Reporting", "Insights"],
      note: "Información real, no presentaciones. Una plataforma para ver, entender y decidir.",
      video: {
        title: "Demo Narwhal: todo el negocio en un solo lugar",
        open: "Ver en YouTube",
        loading: "Cargando video…",
        retry: "Reintentar carga del video",
        unavailable: "No se pudo cargar el reproductor. Podés ver el video directamente en YouTube.",
      },
    },
    process: {
      kicker: "Cómo funciona",
      title: "Un proceso simple. Resultados sostenidos.",
      steps: [
        { n: "01", title: "Diagnóstico" },
        { n: "02", title: "Estrategia" },
        { n: "03", title: "Setup" },
        { n: "04", title: "Día 15: operación" },
        { n: "05", title: "Iteración quincenal" },
        { n: "06", title: "Compounding" },
      ],
      timeline: [
        { tag: "Corto", text: "Todo funcionando." },
        { tag: "Mediano", text: "Señales + pipeline + posicionamiento." },
        { tag: "Largo", text: "Sistema maduro + oportunidades + cierres." },
      ],
    },
    forWhom: {
      kicker: "Para quién y mercados",
      title: "Narwhal no está pensado",
      titleAccent: "para cualquier empresa.",
      body: "El punto en común no es la industria, sino la complejidad de construir crecimiento B2B: ciclos largos, múltiples decisores y la necesidad de combinar resultados en el corto plazo con estrategias de posicionamiento y crecimiento sostenido.",
      marketsLabel: "Experiencia en",
      items: [
        {
          n: "01",
          icon: "laptop",
          title: "SaaS B2B",
          text: "Startups y compañías digitales que necesitan acelerar crecimiento sin construir una estructura completa.",
          checks: ["Ciclos de venta desafiantes", "Mercados competitivos", "Necesidad de escalar"],
        },
        {
          n: "02",
          icon: "users",
          title: "Servicios B2B",
          text: "Ingeniería, consultoría, tecnología y servicios especializados donde la confianza y la autoridad son parte del proceso comercial.",
          checks: ["Múltiples decisores", "Venta basada en confianza", "Necesidad de demanda constante"],
        },
        {
          n: "03",
          icon: "chart",
          title: "Empresas con proyectos específicos",
          text: "Organizaciones con proyectos de alto valor que necesitan visibilidad, posicionamiento y una estrategia comercial sostenida.",
          checks: ["Ciclos largos", "Múltiples áreas involucradas", "Oportunidades de alto valor"],
        },
      ],
    },
    industries: {
      kicker: "Industrias",
      title: "Experiencia en",
      titleAccent: "LATAM, USA y España.",
      regions: ["LATAM", "USA", "España"],
      stats: [
        { value: "+10", label: "años de experiencia" },
        { value: "2", label: "empresas nuevas por mes" },
        { value: "+2.000", label: "contactos únicos / 6 meses" },
      ],
      tags: ["SaaS", "Fintech", "Logística", "IT", "Edtech", "Healthtech", "Cybersecurity", "Industria"],
    },
    cases: {
      kicker: "Casos",
      title: "Resultados en empresas reales.",
      cta: "Ver todos los casos",
      items: [
        { name: "MomentIA", slug: "momentia", sector: "Venture propio · Fotografía con IA", desafio: "Construir una empresa de cero y probar el modelo integral.", sistema: "Modelo de aceleración completo de Narwhal, desde el día uno.", metric: "3x", metricLabel: "facturación mes a mes, en 4 meses" },
        { name: "Xcapit", slug: "xcapit", sector: "B2B · Tecnología · LATAM", desafio: "Sin reuniones comerciales y con SEO de negocio casi en cero.", sistema: "Outbound desde cero + Comunicación + SEO/AEO/GEO + Paid.", metric: "76", metricLabel: "reuniones con cuentas como Visa, Globant y P&G" },
        { name: "Monico", slug: "monico", sector: "B2B · SaaS · Licitaciones · México", desafio: "SaaS técnico de nicho, sin motor comercial ni presencia de marca.", sistema: "Outbound desde cero + Comunicación + Paid + Dirección.", metric: "56", metricLabel: "reuniones, todas Tier 1 de farma" },
        { name: "Brainmart", sector: "HealthTech · LATAM", desafio: "Posicionamiento y generación de demanda.", sistema: "Contenido + SEO/GEO + outbound.", metric: "4 meses", metricLabel: "de crecimiento del pipeline" },
        { name: "Bridar", slug: "bridar", sector: "B2B · Sector mega competitivo", desafio: "Web sin indexar, sin visibilidad ni leads orgánicos.", sistema: "Dirección de Negocios completa: BizDev + Comunicación + SEO/AEO/GEO + Paid.", metric: "USD 1.28M", metricLabel: "pipeline activo generado, desde cero" },
        { name: "For_me", slug: "forme", sector: "B2B · Clientes enterprise", desafio: "Sin motor comercial, visibilidad orgánica y en IA limitada.", sistema: "Outbound escalado + Comunicación + SEO/AEO/GEO + Paid.", metric: "+3167%", metricLabel: "menciones en IA en un trimestre" },
        { name: "WeRelo", slug: "werelo", sector: "Fleet logistics · Canadá", desafio: "Sin motor comercial y baja visibilidad de marca.", sistema: "Outbound desde cero + Comunicación + SEO/AEO/GEO + Paid.", metric: "+417%", metricLabel: "keywords en Top 3 de Google" },
        { name: "Nearcore", slug: "nearcore", sector: "B2B · Nearshore staff augmentation · US", desafio: "Consolidarse como marca propia, diferenciada de su empresa madre.", sistema: "Estrategia de Negocios + Consolidación de mercado + Posicionamiento.", metric: "15 días", metricLabel: "estrategia lista para ejecutar" },
      ],
      resultLabel: "Resultado",
      desafioLabel: "Desafío",
      sistemaLabel: "Sistema activado",
      caseCta: "Ver caso",
    },
    additional: {
      kicker: "Servicios adicionales",
      title: "Cuando la base funciona,",
      titleAccent: "podemos ir más lejos.",
      cta: "Explorar servicios",
      items: [
        { title: "SEO / GEO / AEO", text: "Más visibilidad en Google y motores de IA.", badge: "También independiente" },
        { title: "PR", text: "Autoridad externa y señales para buscadores.", badge: "También independiente" },
        { title: "Branding institucional", text: "Expandí la presencia de tu marca.", badge: "" },
      ],
    },
    team: {
      kicker: "Nuestro equipo",
      title: "Un equipo que se involucra",
      titleAccent: "de verdad.",
      body: "Más de 15 profesionales senior. 4 gerencias. 1 Dirección. Trabajamos como parte de tu empresa.",
      cta: "Conocé Narwhal",
      stats: [
        { value: "+15", label: "profesionales" },
        { value: "4", label: "gerencias" },
        { value: "1", label: "dirección" },
        { value: "1", label: "propósito" },
      ],
      aboutTitle: "Preferimos narvales a unicornios.",
      aboutBody: "Creemos en el trabajo constante, la colaboración y en construir algo real y sostenible.",
    },
    resources: {
      kicker: "Recursos",
      title: "Ideas para impulsar",
      titleAccent: "tu negocio B2B.",
      cta: "Ver todas",
      items: [
        { tag: "Insight", title: "Por qué el outbound solo no alcanza en B2B", img: BLOG_IMG.sales, cta: "Leer nota" },
        { tag: "Guía", title: "Cómo aparecer en ChatGPT, Gemini y Perplexity", img: BLOG_IMG.ai, cta: "Leer guía" },
        { tag: "Caso", title: "Cómo estructurar un ecosistema comercial B2B", img: BLOG_IMG.eco, cta: "Leer caso" },
      ],
    },
    faqs: {
      kicker: "FAQ",
      title: "Preguntas frecuentes.",
      items: [
        { q: "¿Qué incluye el fee mensual?", a: "Un equipo de +15 profesionales en 4 gerencias más la Dirección de Negocios, todo el stack tecnológico (licencias, herramientas e integraciones), reporting, reuniones quincenales y documentación. Solo la tecnología ya representa cerca del 40% del fee." },
        { q: "¿Hay permanencia mínima?", a: "No. No hay retainer ni permanencias mínimas. Buscamos que te quedes por el valor que recibís, no porque estás atado a un contrato." },
        { q: "¿En cuánto tiempo están operando?", a: "En 15 días pasás de nada a un ecosistema completo funcionando, con todas las iniciativas saliendo en paralelo y un primer ciclo de retroalimentación y ajuste." },
        { q: "¿Qué resultados puedo esperar?", a: "Corto plazo: activación, presencia y pipeline inicial. Mediano: posicionamiento y validación de narrativa. Largo: crecimiento sostenido. Los primeros cierres, que no dependen solo de Narwhal, suelen aparecer a partir del mes 7, el ritmo natural del B2B." },
        { q: "¿Para qué tipo de empresas funciona?", a: "SaaS B2B (mayor fit), otros servicios B2B sin dependencia geográfica, y empresas más grandes con proyectos puntuales. El común denominador: venta compleja, ciclos largos y múltiples decisores." },
        { q: "¿Qué pasa si en el futuro quiero sumar más servicios?", a: "Podés sumar capas adicionales a pedido: SEO/GEO/AEO avanzado, PR, branding institucional, eventos y community building. Siempre para complementar lo que ya funciona." },
      ],
    },
    ctaBanner: {
      title: "Podés seguir sumando proveedores.",
      titleAccent: "O sumar una Dirección.",
      cta: "Agendá una revisión estratégica",
      note: "Tomamos hasta 2 empresas nuevas por mes.",
    },
    contact: {
      kicker: "Contacto",
      title: "Hablemos de",
      titleAccent: "tu próximo paso.",
      body: "Contanos un poco sobre tu empresa y coordinamos una llamada.",
      fields: { name: "Nombre", email: "Email corporativo", org: "Empresa", phone: "Teléfono", role: "Rol / Cargo", message: "Mensaje (opcional)" },
      submit: "Solicitar una llamada",
      success: "¡Gracias! Nos pondremos en contacto muy pronto.",
      required: "Por favor completá nombre, email y empresa.",
      altTitle: "También podés escribirnos",
      alts: [
        { label: "tsarmiento@narwhalhub.com", type: "email", href: "mailto:tsarmiento@narwhalhub.com" },
        { label: "LinkedIn", type: "linkedin", href: "https://www.linkedin.com/company/narwhalhubb" },
        { label: "Agendá una reunión", type: "calendar" },
      ],
    },
    footer: {
      tagline: "Dirección de Negocios B2B as a Service.",
      rights: "Todos los derechos reservados.",
      regions: "LATAM · USA · España",
      cols: [
        { title: "Modelo", links: [
          { id: "modelo", label: "El modelo" },
          { id: "por-que-narwhal", label: "Por qué Narwhal" },
          { id: "como-funciona", label: "Cómo funciona" },
          { id: "precio", label: "Precio" },
        ] },
        { title: "Servicios", links: [
          { id: "dce", href: "/direccion-comercial-externa", label: "Dirección Comercial Externa" },
          { id: "model-area-0", label: "Desarrollo de Negocios ABM" },
          { id: "model-area-1", label: "Marketing ABM" },
          { id: "model-area-2", label: "Comunicación & Posicionamiento" },
          { id: "model-area-3", label: "Tech, Datos & Performance" },
        ] },
        { title: "Explorar", links: [
          { id: "para-quien", label: "Para quién y mercados" },
          { id: "casos", label: "Casos" },
          { id: "faqs", href: "/faq", label: "Preguntas frecuentes" },
          { id: "glosario", href: "/glosario", label: "Glosario" },
          { id: "descargables", href: "/descargables", label: "Descargables" },
          { id: "contacto", label: "Contacto" },
        ] },
      ],
    },
  },

  en: {
    nav: {
      links: [
        { id: "inicio", label: "Narwhal" },
        { id: "nosotros", label: "About" },
        { id: "servicios", label: "Services" },
        { id: "recursos", label: "Resources", dropdown: [
          { label: "Blog", section: "blogs" },
          { label: "Success stories", section: "casos" },
          { label: "FAQ", section: "faq" },
          { label: "Glossary", section: "glosario" },
          { label: "Downloads", section: "descargables" },
        ] },
      ],
      cta: "Book a call",
      menu: "Navigation menu",
      closeMenu: "Close menu",
      home: "Narwhal - Home",
    },
    hero: {
      kicker: "Commercial acceleration",
      titleTop: "Your Business Leadership",
      titleAccent: "B2B as a Service.",
      titleAccentLines: ["B2B as a Service."],
      imageAlt: "Narwhal dashboard with its official logo, boosted revenue, generated leads, active projects, meetings and pipeline growth.",
      sub: "B2B requires coordinating long sales cycles, multiple decision-makers and efforts that must be sustained without interruption. Narwhal builds and sustains that complete team under unified leadership.",
      cta: "Book a call",
      cta2: "Discover Layer 1",
      tagline: "Strategy × Execution × Results",
      dashboard: {
        label: "Pipeline",
        value: "$2.4M",
        metrics: [
          { label: "Leads", value: "342" },
          { label: "Meetings", value: "87" },
          { label: "Opportunities", value: "23" },
          { label: "Conversions", value: "12" },
        ],
        note: "Your entire B2B operation in one place.",
      },
    },
    stats: [
      { value: "+15", label: "professionals on your team" },
      { value: "4", label: "units + 1 Direction" },
      { value: "+8", label: "simultaneous strategies" },
      { value: "15 days", label: "to be operating" },
    ],
    problem: {
      kicker: "The problem with B2B growth",
      title: "Every solution solves one part",
      titleAccent: "and adds new challenges.",
      body: "In-house teams, agencies, consultants and vendors can add value, but they also introduce new complexities that limit growth.",
      columns: [
        { name: "In-house teams", caption: "Great talent, but not enough.", points: ["Months to build the structure", "High fixed cost", "Need for multiple specialized profiles", "Management and coordination complexity", "Dependence on key people"] },
        { name: "Agencies / vendors", caption: "Specialists by area, but no complete vision.", points: ["Work per channel or service", "Costs accumulated across vendors", "Constant upselling", "Need for internal coordination", "Disconnected efforts"] },
        { name: "Consultants", caption: "Strategy without operational involvement.", points: ["They diagnose", "They don't run the day-to-day", "Long processes", "Require additional internal resources", "Low exposure to results"] },
      ],
    },
    challenge: {
      kicker: "The real challenge",
      title: "B2B growth doesn't have a",
      titleAccent: "single challenge.",
      body: "Multiple challenges interact and amplify each other. Solving one part isn't enough if the others keep limiting the result.",
      orbit: ["Strategy", "Technology", "Data", "Execution", "Demand"],
      items: [
        { icon: "network", title: "Structural complexity", text: "There's no single front to fix: multiple interdependent strategies must work and hold up at the same time." },
        { icon: "coins", title: "Economic constraint", text: "Building the full capability in-house is costly, and outsourcing it in parts piles up fees, tools and coordination." },
        { icon: "clock", title: "Time constraint", text: "Building teams, adding know-how and setting up processes takes months, but the business can't stop selling." },
        { icon: "alert", title: "Accumulated wear", text: "People, agencies and initiatives solved parts, not the whole. Each failed attempt adds cost, time and distrust." },
        { icon: "chart", title: "Competitive pressure", text: "While you organize your commercial system, the market moves on. Doing nothing is also a cost." },
        { icon: "user", title: "Leadership burden", text: "Someone has to decide, coordinate and monitor everything, with no single dashboard. That burden falls on the CEO or sales lead." },
        { icon: "eye", title: "Low visibility", text: "It's hard to know what's being done, whether things are moving, if there are results and who's working on what, with no single place to check it quickly." },
      ],
      closingTitle: "Narwhal doesn't solve one of these challenges.",
      closingAccent: "It solves the problem of carrying them all at once.",
    },
    model: {
      kicker: "The model",
      title: "From zero to a team",
      titleSecondLine: "up and running in",
      titleAccent: "15 days.",
      body: "For a single fee, with no structural upselling and no learning curve, a CEO goes from zero to a complete ecosystem up and running.",
      chart: {
        root: "Business Direction",
        rootCaption: "Strategy, coordination and results",
        orgTagline: "One team. One direction.",
        areas: [
          { title: "Business Development", description: "Real pipeline, not just leads.", items: ["Strategic outbound", "Account research", "Opportunity management"] },
          { title: "Marketing", description: "Demand that connects to business.", items: ["Strategy & campaigns", "SEO / GEO", "Content & performance"] },
          { title: "Communication & Positioning", description: "Reputation that creates opportunities.", items: ["LinkedIn & PR", "Strategic content", "Events & partnerships"] },
          { title: "Tech, Data & Performance", description: "Infrastructure to scale.", items: ["CRM & automation", "Data & reporting", "Continuous optimization"] },
        ],
        nodes: ["Business Development ABM", "Marketing ABM", "Communication & Positioning", "Tech, Data & Performance"],
      },
      price: {
        label: "One monthly fee",
        amount: "USD 3,200",
        per: "/mo",
        checks: ["No retainer or minimum commitment.", "Full tech stack included."],
        includesTitle: "Includes",
        includes: ["+15 professionals", "4 management units", "Business Direction", "Tech stack", "Ongoing reporting", "Biweekly meetings", "Documentation & know-how"],
        cta: "I want my strategic review",
      },
    },
    why: {
      kicker: "Why Narwhal",
      title: "The only model that takes on",
      titleAccent: "the full complexity of B2B.",
      items: [
        {
          title: "Minimum viable ecosystem", text: "The indispensable base, executed with professionalism.",
          definition: "It's everything your company should be doing no matter what to compete in the short, medium and long term. There are a thousand possible things, but there's an indispensable base: all the necessary fronts work coordinated and executed with professionalism, not as scattered actions.",
        },
        {
          title: "Peace of mind", text: "Knowing everything that should be done is being done.",
          definition: "It's not a vague feeling: it's the direct result of full traceability and month-to-month reporting. There's always someone who tells you how each front is progressing.",
        },
        {
          title: "Business partner", text: "A real in-house team, not just another vendor.",
          definition: "We want you to feel you added an internal team aligned with your goals. We bring the know-how and judgment as if we were part of your company, not just another external vendor.",
        },
        {
          title: "Transparency", text: "Real results, good or bad, without dressing them up.",
          definition: "We share results exactly as they are, without inflating metrics to justify the fee. That honesty is the basis of the peace of mind Narwhal offers: not a promise that everything will go well, but the certainty of seeing it as it is, always, thanks to our own technology that reports everything.",
        },
        {
          title: "Full visibility", text: "The whole operation on a proprietary platform.",
          definition: "Narwhal's proprietary technology platform brings every tool and channel together. From one place, you see absolutely everything with real data: not only our execution, but every indicator that emerges along the way.",
        },
        {
          title: "Opportunity cost", text: "The best possible result with the lowest investment.",
          definition: "For USD 3,200 today you barely get two semi-senior profiles or one senior, with no guarantee they'll know what to do or cover everything. An agency already approaches that ticket with a single strategy, starting from scratch each time and disconnected from the rest of the business. No comparable alternative exists at that price.",
        },
        {
          title: "Proprietary technology", text: "The full stack, already built and tested.",
          definition: "We cover the entire tech stack, but the core is our own technology that integrates every platform and reports absolutely everything. It's already built and tested, without the months of development it would take to build it from scratch.",
        },
        {
          title: "No learning curve", text: "The ecosystem is already running.",
          definition: "The ecosystem is already built and running; it isn't rebuilt from scratch for each client. You start operating without months of setup.",
        },
        {
          title: "One single fee", text: "No forced upselling or hidden costs.",
          definition: "The fee includes the entire technology stack and doesn't depend on justifying activity or selling you additional service layers. Many things an agency would charge separately, we include.",
        },
        {
          title: "No lock-in", text: "You stay for the value you receive.",
          definition: "There is no retainer or minimum commitment. We want you to stay because of the value you receive, not because you are tied to a contract. The relationship is sustained by the team's contribution to your business.",
        },
        {
          title: "Senior team", text: "No juniors learning on the fly.",
          definition: "More than 15 professionals, organized across four management units and one Business Direction. A dedicated senior team that contributes expertise and judgment as part of your company, rather than junior resources learning on the fly.",
        },
        {
          title: "Know-how that stays", text: "Processes and knowledge for your company.",
          definition: "The knowledge and judgment developed stay with you, not locked inside the provider. Documentation and processes are part of the work, so your company keeps what it has learned and can continue building on that foundation.",
        },
      ],
      link: "Explore the differentiators",
      detail: { label: "Differentiator", previous: "Previous differentiator", next: "Next differentiator", close: "Close details" },
    },
    tech: {
      kicker: "Tech driven",
      title: "The whole business in one place.",
      body: "Narwhal's proprietary technology platform integrates every tool and channel. From a single place you see absolutely everything with real data: not just our execution, but every indicator as it comes out.",
      list: ["Business Development", "Sales Pipeline", "AI, Search & Visibility", "Content & Brand", "Paid Media", "Operations Management", "Reporting", "Insights"],
      note: "Real data, not slide decks. One platform to see, understand and decide.",
      video: {
        title: "Narwhal demo: the whole business in one place",
        open: "Watch on YouTube",
        loading: "Loading video…",
        retry: "Retry loading video",
        unavailable: "The player could not load. You can watch the video directly on YouTube.",
      },
    },
    process: {
      kicker: "How it works",
      title: "A simple process. Sustained results.",
      steps: [
        { n: "01", title: "Diagnosis" },
        { n: "02", title: "Strategy" },
        { n: "03", title: "Setup" },
        { n: "04", title: "Day 15: operating" },
        { n: "05", title: "Biweekly iteration" },
        { n: "06", title: "Compounding" },
      ],
      timeline: [
        { tag: "Short", text: "Everything running." },
        { tag: "Mid", text: "Signals + pipeline + positioning." },
        { tag: "Long", text: "Mature system + opportunities + closes." },
      ],
    },
    forWhom: {
      kicker: "Who it's for & markets",
      title: "Narwhal isn't meant",
      titleAccent: "for every company.",
      body: "The common thread isn't the industry, but the complexity of building B2B growth: long cycles, multiple decision-makers and the need to combine short-term results with positioning and sustained growth strategies.",
      marketsLabel: "Experience in",
      items: [
        {
          n: "01",
          icon: "laptop",
          title: "B2B SaaS",
          text: "Startups and digital companies that need to accelerate growth without building a full structure.",
          checks: ["Challenging sales cycles", "Competitive markets", "Need to scale"],
        },
        {
          n: "02",
          icon: "users",
          title: "B2B services",
          text: "Engineering, consulting, technology and specialized services where trust and authority are part of the commercial process.",
          checks: ["Multiple decision-makers", "Trust-based selling", "Need for constant demand"],
        },
        {
          n: "03",
          icon: "chart",
          title: "Companies with specific projects",
          text: "Organizations with high-value projects that need visibility, positioning and a sustained commercial strategy.",
          checks: ["Long cycles", "Multiple areas involved", "High-value opportunities"],
        },
      ],
    },
    industries: {
      kicker: "Industries",
      title: "Experience in",
      titleAccent: "LATAM, USA and Spain.",
      regions: ["LATAM", "USA", "Spain"],
      stats: [
        { value: "+10", label: "years of experience" },
        { value: "2", label: "new companies per month" },
        { value: "+2,000", label: "unique contacts / 6 months" },
      ],
      tags: ["SaaS", "Fintech", "Logistics", "IT", "Edtech", "Healthtech", "Cybersecurity", "Industry"],
    },
    cases: {
      kicker: "Cases",
      title: "Results in real companies.",
      cta: "See all cases",
      items: [
        { name: "MomentIA", slug: "momentia", sector: "Own venture · AI photography", desafio: "Build a company from scratch and prove the integral model.", sistema: "Narwhal's full acceleration model, from day one.", metric: "3x", metricLabel: "revenue month over month, in 4 months" },
        { name: "Xcapit", slug: "xcapit", sector: "B2B · Technology · LATAM", desafio: "No commercial meetings and business SEO near zero.", sistema: "Outbound from scratch + Communication + SEO/AEO/GEO + Paid.", metric: "76", metricLabel: "meetings with accounts like Visa, Globant and P&G" },
        { name: "Monico", slug: "monico", sector: "B2B · SaaS · Tenders · Mexico", desafio: "Technical niche SaaS, no commercial engine or brand presence.", sistema: "Outbound from scratch + Communication + Paid + Leadership.", metric: "56", metricLabel: "meetings, all Tier 1 pharma" },
        { name: "Brainmart", sector: "HealthTech · LATAM", desafio: "Positioning and demand generation.", sistema: "Content + SEO/GEO + outbound.", metric: "4 months", metricLabel: "of pipeline growth" },
        { name: "Bridar", slug: "bridar", sector: "B2B · Highly competitive sector", desafio: "Non-indexed website, no visibility or organic leads.", sistema: "Full Business Leadership: BizDev + Communication + SEO/AEO/GEO + Paid.", metric: "USD 1.28M", metricLabel: "active pipeline generated, from zero" },
        { name: "For_me", slug: "forme", sector: "B2B · Enterprise clients", desafio: "No commercial engine, limited organic and AI visibility.", sistema: "Scaled outbound + Communication + SEO/AEO/GEO + Paid.", metric: "+3167%", metricLabel: "AI mentions in one quarter" },
        { name: "WeRelo", slug: "werelo", sector: "Fleet logistics · Canada", desafio: "No commercial engine and low brand visibility.", sistema: "Outbound from scratch + Communication + SEO/AEO/GEO + Paid.", metric: "+417%", metricLabel: "keywords in Google Top 3" },
        { name: "Nearcore", slug: "nearcore", sector: "B2B · Nearshore staff augmentation · US", desafio: "Consolidate as its own brand, differentiated from its parent company.", sistema: "Business Strategy + Market consolidation + Positioning.", metric: "15 days", metricLabel: "strategy ready to execute" },
      ],
      resultLabel: "Result",
      desafioLabel: "Challenge",
      sistemaLabel: "System activated",
      caseCta: "See case",
    },
    additional: {
      kicker: "Additional services",
      title: "When the base works,",
      titleAccent: "we can go further.",
      cta: "Explore services",
      items: [
        { title: "SEO / GEO / AEO", text: "More visibility on Google and AI engines.", badge: "Also standalone" },
        { title: "PR", text: "External authority and signals for search.", badge: "Also standalone" },
        { title: "Institutional branding", text: "Expand your brand's presence.", badge: "" },
      ],
    },
    team: {
      kicker: "Our team",
      title: "A team that truly",
      titleAccent: "gets involved.",
      body: "More than 15 senior professionals. 4 units. 1 Direction. We work as part of your company.",
      cta: "Meet Narwhal",
      stats: [
        { value: "+15", label: "professionals" },
        { value: "4", label: "units" },
        { value: "1", label: "direction" },
        { value: "1", label: "purpose" },
      ],
      aboutTitle: "We prefer narwhals to unicorns.",
      aboutBody: "We believe in constant work, collaboration and building something real and sustainable.",
    },
    resources: {
      kicker: "Resources",
      title: "Ideas to grow",
      titleAccent: "your B2B business.",
      cta: "See all",
      items: [
        { tag: "Insight", title: "Why outbound alone isn't enough in B2B", img: BLOG_IMG.sales, cta: "Read note" },
        { tag: "Guide", title: "How to show up in ChatGPT, Gemini and Perplexity", img: BLOG_IMG.ai, cta: "Read guide" },
        { tag: "Case", title: "How to structure a B2B commercial ecosystem", img: BLOG_IMG.eco, cta: "Read case" },
      ],
    },
    faqs: {
      kicker: "FAQ",
      title: "Frequently asked questions.",
      items: [
        { q: "What does the monthly fee include?", a: "A team of 15+ professionals across 4 units plus Business Direction, the full tech stack (licenses, tools and integrations), reporting, biweekly meetings and documentation. Technology alone represents about 40% of the fee." },
        { q: "Is there a minimum commitment?", a: "No. No retainer or minimum commitment. We want you to stay for the value you receive, not because you're tied to a contract." },
        { q: "How long until you're operating?", a: "In 15 days you go from nothing to a complete ecosystem running, with all initiatives launching in parallel and a first feedback-and-adjust cycle." },
        { q: "What results can I expect?", a: "Short term: activation, presence and initial pipeline. Mid: positioning and narrative validation. Long: sustained growth. First closes, which don't depend on Narwhal alone, usually appear from month 7, the natural rhythm of B2B." },
        { q: "What type of companies does it work for?", a: "B2B SaaS (best fit), other B2B services without geographic dependence, and larger companies with specific projects. The common denominator: complex sales, long cycles and multiple decision-makers." },
        { q: "What if I want to add more services later?", a: "You can add layers on demand: advanced SEO/GEO/AEO, PR, institutional branding, events and community building. Always to complement what already works." },
      ],
    },
    ctaBanner: {
      title: "You can keep adding vendors.",
      titleAccent: "Or add a Direction.",
      cta: "Book a strategic review",
      note: "We take up to 2 new companies per month.",
    },
    contact: {
      kicker: "Contact",
      title: "Let's talk about",
      titleAccent: "your next step.",
      body: "Tell us a bit about your company and we'll set up a call.",
      fields: { name: "Name", email: "Work email", org: "Company", phone: "Phone", role: "Role / Title", message: "Message (optional)" },
      submit: "Request a call",
      success: "Thank you! We'll be in touch very soon.",
      required: "Please complete name, email and company.",
      altTitle: "You can also reach us",
      alts: [
        { label: "tsarmiento@narwhalhub.com", type: "email", href: "mailto:tsarmiento@narwhalhub.com" },
        { label: "LinkedIn", type: "linkedin", href: "https://www.linkedin.com/company/narwhalhubb" },
        { label: "Book a meeting", type: "calendar" },
      ],
    },
    footer: {
      tagline: "B2B Business Direction as a Service.",
      rights: "All rights reserved.",
      regions: "LATAM · USA · Spain",
      cols: [
        { title: "Model", links: [
          { id: "modelo", label: "The model" },
          { id: "por-que-narwhal", label: "Why Narwhal" },
          { id: "como-funciona", label: "How it works" },
          { id: "precio", label: "Pricing" },
        ] },
        { title: "Services", links: [
          { id: "dce", href: "/direccion-comercial-externa", label: "External Commercial Direction" },
          { id: "model-area-0", label: "Business Development ABM" },
          { id: "model-area-1", label: "Marketing ABM" },
          { id: "model-area-2", label: "Communication & Positioning" },
          { id: "model-area-3", label: "Tech, Data & Performance" },
        ] },
        { title: "Explore", links: [
          { id: "para-quien", label: "Who it's for & markets" },
          { id: "casos", label: "Cases" },
          { id: "faqs", href: "/faq", label: "Frequently asked questions" },
          { id: "glosario", href: "/glosario", label: "Glossary" },
          { id: "descargables", href: "/descargables", label: "Downloads" },
          { id: "contacto", label: "Contact" },
        ] },
      ],
    },
  },
};

export default content;
